import { getAuthHeaders } from './authActions'

const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001'

export const getCurrentUser = async () => {
	const res = await fetch(`${BASE_URL}/api/user/me`, {
		method: 'GET',
		headers: {
			...getAuthHeaders(),
		},
	})

	if (!res.ok) {
		throw new Error('Failed to fetch current user')
	}

	return res.json()
}

export const getOrgUsers = async () => {
	const res = await fetch(`${BASE_URL}/api/user/org-users`, {
		method: 'GET',
		headers: {
			...getAuthHeaders(),
		},
	})

	if (!res.ok) {
		throw new Error('Failed to fetch organization users')
	}

	return res.json()
}

export const updateUserRole = async (userId, role) => {
	const res = await fetch(`${BASE_URL}/api/user/${userId}`, {
		method: 'PATCH',
		headers: {
			...getAuthHeaders(),
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({ role }),
	})

	if (!res.ok) {
		throw new Error('Failed to update user role')
	}

	return res.json()
}

export const createOrgUser = async (userData) => {
	const res = await fetch(`${BASE_URL}/api/user`, {
		method: 'POST',
		headers: {
			...getAuthHeaders(),
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(userData),
	})

	if (!res.ok) {
		throw new Error('Failed to create user')
	}

	return res.json()
}

export const updateCurrentExperience = async (currentExperienceId) => {
	const res = await fetch(`${BASE_URL}/api/user/me`, {
		method: 'PATCH',
		headers: {
			...getAuthHeaders(),
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({ currentExperienceId }),
	})

	if (!res.ok) {
		throw new Error('Failed to update current experience')
	}

	const data = await res.json()

	// 👇 If the server gives us a new token, save it
	if (data.token) {
		localStorage.setItem('token', data.token)
	}

	return data
}
